import React from 'react';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import SubscriptionDialog, { DialogButton, DialogNotice } from '../../../components/subscription/SubscriptionDialog';
import usePlanChangeSimulation from './usePlanChangeSimulation';
import { buildDowngradeLosses } from './planChangeLists';
import { PlanChangeComparison, PlanChangeList } from './PlanChangeParts';
import PlanChangeCreditValues from './PlanChangeCreditValues';
import styles from './PlanChangeModal.module.css';

/**
 * Confirmação da troca para um plano menor de quem já assina, quando a conta já
 * cabe no plano novo (se não cabe, a tela abre o PlanFitModal). Mesmo layout do
 * UpgradePlanModal: de -> para, o que deixa de ter, crédito e próxima cobrança.
 */
const DowngradePlanModal = ({
  open,
  currentPlan,
  newPlan,
  loading = false,
  error = null,
  onConfirm,
  onCancel,
}) => {
  const preview = usePlanChangeSimulation(newPlan?.id, !!open);

  if (!open || !newPlan) return null;

  const losses = buildDowngradeLosses(currentPlan?.config || null, newPlan?.config || null);

  return (
    <SubscriptionDialog
      open
      onClose={onCancel}
      locked={loading}
      title={<>Trocar para o plano <span className={styles.titleHighlight}>{newPlan.name}</span></>}
      subtitle={`Vale a partir de agora: recursos e limites passam a ser os do plano ${newPlan.name}.`}
      secondaryAction={(
        <DialogButton variant="text" onClick={onCancel} disabled={loading}>
          Cancelar
        </DialogButton>
      )}
      actions={(
        <DialogButton onClick={() => onConfirm(newPlan)} loading={loading} loadingLabel="Trocando...">
          {`Trocar para o ${newPlan.name}`}
        </DialogButton>
      )}
    >
      <PlanChangeComparison currentPlan={currentPlan} newPlan={newPlan} />
      <PlanChangeList title="O que deixa de ter" items={losses} tone="loss" />
      <PlanChangeCreditValues {...preview} />
      {error && (
        <DialogNotice tone="error" icon={<ErrorOutlineIcon fontSize="inherit" />}>
          {error}
        </DialogNotice>
      )}
    </SubscriptionDialog>
  );
};

export default DowngradePlanModal;
